// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2_pd4","itemTitle":"ClientEmergencyInfo_itemTitle__PQhIS","itemText":"ClientEmergencyInfo_itemText__1SvZr"};